import React, { Component } from 'react';
import {
  MDBContainer,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
} from 'mdbreact';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import DataTable from './DataTable';
import BarGraph from './Bar Graph';

class FloatTabs extends Component {
  state = {
    activeItem: '1',
  };

  toggle = (tab) => (_) => {
    if (this.state.activeItem !== tab) {
      this.setState({
        activeItem: tab,
      });
    }
  };

  render() {
    // console.log('eventData:', this.props.eventData); // Add this line

    return (
      <MDBContainer>
        <MDBNav className="nav-justified nav-tabs mt-5">
          <MDBNavItem>
            <MDBNavLink
              link
              to="#"
              active={this.state.activeItem === '1'}
              onClick={this.toggle('1')}
              role="tab"
            >
              Events Attended
              {' '}
            </MDBNavLink>
            {' '}
          </MDBNavItem>
          {' '}
          <MDBNavItem>
            <MDBNavLink
              link
              to="#"
              active={this.state.activeItem === '2'}
              onClick={this.toggle('2')}
              role="tab"
            >
              Category - Wise Hours
              {' '}
            </MDBNavLink>
            {' '}
          </MDBNavItem>
          {' '}
        </MDBNav>
        {' '}
        <MDBTabContent activeItem={this.state.activeItem}>
          <MDBTabPane tabId="1" role="tabpanel">
            <DataTable
              tableName="Events Attended"
              data={this.props.eventData}
              error={this.props.eventDataError}
              columns={[
                { name: 'Event Name', options: { filter: false } },
                { name: 'Category', numerical: true },
                { name: 'Hours Awarded', numerical: true },
                { name: 'Event Date', options: { filter: false } },
                { name: 'Remarks', options: { filter: false } },
              ]}
              options={{
                rowsPerPage: 15,
                rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
                download: false,
              }}
            />
            {' '}
          </MDBTabPane>
          {' '}
          <MDBTabPane tabId="2" role="tabpanel">
            <BarGraph
              data={this.props.categoryData}
              error={this.props.categoryDataError}
            />
          </MDBTabPane>
          {' '}
        </MDBTabContent>
        {' '}
      </MDBContainer>
    );
  }
}
export default FloatTabs;
